export const globeMarkerTemplates:Record<string,string>={
    pin:`<svg viewBox="-4 0 36 36" width="30" style="position:absolute;bottom:0;left:50%;transform:translateX(-50%)">
    <path fill="white" d="M14,0 C21.732,0 28,5.641 28,12.6 C28,23.963 14,36 14,36 C14,36 0,24.064 0,12.6 C0,5.641 6.268,0 14,0 Z"></path>
    <circle fill="black" cx="14" cy="14" r="7"></circle>
  </svg>`
}